import { useEffect } from 'react';
import chartPresets from '@meitu/saas-editor-core/es/layers/chart-layer/presets';
import { loadEcharts } from '@meitu/saas-editor-core/es/layers/chart-layer/utils/core';
import { useLocaleStore } from '@/i18n';
import { BlockContainer } from '../../components';
import './style.less';

interface Props {
    onOpenChartPanel: () => void;
    onAddChart: (presetId: string) => void;
}

const ChartShortcut: React.FC<Props> = ({ onOpenChartPanel, onAddChart }) => {
    const { $t } = useLocaleStore();
    useEffect(() => {
        loadEcharts();
    }, []);
    return (
        <BlockContainer
            className="chart-shortcut"
            title={$t((v) => v.collapse.moreCollapse.chartTool.title)}
            onFindMore={onOpenChartPanel}
        >
            <div className="chart-shortcut__btns">
                {chartPresets.slice(0, 6).map((preset) => (
                    <div
                        key={preset.id}
                        className="shortcut-btn chart-shortcut__btn"
                        onClick={() => onAddChart(preset.id)}
                    >
                        <img draggable={false} className="chart-shortcut__img" src={preset.preview} />
                    </div>
                ))}
            </div>
        </BlockContainer>
    );
};

ChartShortcut.displayName = 'ChartShortcut';

export default ChartShortcut;
